
import { Component, Vue } from 'bits/vue'
import OzIcon from 'library/v4/components/OzIcon.vue'
import OzIconButton, { OzIconButtonColorScheme } from 'library/v4/components/OzIconButton.vue'
import LocaleSelector from 'vuecomponents/LocaleSelectorVuex.vue'

@Component({ components: { OzIcon, OzIconButton, LocaleSelector } })
export default class AuthBottomNav extends Vue {
  OzIconButtonColorScheme = OzIconButtonColorScheme
}
